import { render, staticRenderFns } from "./StandardAPIBuild.vue?vue&type=template&id=2b092fba&scoped=true&"
import script from "./StandardAPIBuild.vue?vue&type=script&lang=js&"
export * from "./StandardAPIBuild.vue?vue&type=script&lang=js&"
import style0 from "./StandardAPIBuild.vue?vue&type=style&index=0&id=2b092fba&scoped=true&lang=css&"
import style1 from "./StandardAPIBuild.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b092fba",
  null
  
)

export default component.exports